import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const requestDemo = (data) =>
  axios.post(`${constants.apiHost}/book-demo/new`, data, {
    headers: headersProvider(),
  });
